/* eslint-disable @typescript-eslint/no-explicit-any */
export interface GADataLayer {
  [key: string]: any;
}
